<div class="headerFlexW pr-4 m-3">
    <div class="content-block">
        <div class="bread-crumbs"><a [routerLink]="['/dash/programs/']">Programas</a> / <span *ngIf="!isEditing">Nuevo
                Programa</span><span *ngIf="isEditing">Editando</span></div>
        <h2 class="">Programas</h2>
    </div>
</div>
<div class="dx-card content-block pt-3">
    <!-- TOP CONTAINER  -->
    <div class="flex flex-nowrap">
        <!-- Left  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Datos generales</h3>
            <div class="round-border-2">
                <div class="dx-field">
                    <div class="dx-field-label">Nombre del programa</div>
                    <div class="dx-field-value">
                        <dx-text-box [(value)]="program.name">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Inicio del programa</div>
                    <div class='dx-field-value'>
                        <dx-date-box [(value)]="tempStartDate" width="100%" placeholder="Inicio">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-date-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Final del programa</div>
                    <div class='dx-field-value'>
                        <dx-date-box [(value)]="tempEndDate" width="100%" placeholder="Final">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-date-box>
                    </div>
                </div>
            </div>

        </div>
        <!-- Right  -->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Parámetros generales</h3>
            <div class="round-border-2">
                <div class='dx-field'>
                    <div class='dx-field-label'>Existe un máximo por dispersión?</div>
                    <div class='dx-field-value'>
                        <dx-switch #switchO [(value)]="program.hasDispersionMax">
                        </dx-switch>
                    </div>
                </div>
                <div class='dx-field' *ngIf="program.hasDispersionMax">
                    <div class='dx-field-label'>Maximo por dispersión</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.dispersionMaxAmount">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Existe un máximo por dispersión por tarjeta?</div>
                    <div class='dx-field-value'>
                        <dx-switch #switchO [(value)]="program.hasCardDispersionMax">
                        </dx-switch>
                    </div>
                </div>
                <div class='dx-field' *ngIf="program.hasCardDispersionMax">
                    <div class='dx-field-label'>Maximo por dispersión por tarjeta</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.cardDispersionMaxAmount">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Requerido"></dxi-validation-rule>
                            </dx-validator>
                        </dx-number-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- BOTTOM CONTAINER  -->
    <div class="flex flex-nowrap">
        <!-- PARAMETROS DE COSTOS  LEFT-->
        <div class=" responsive-paddings flex-grow-1">
            <h3>Costos para empresa</h3>
            <div class="round-border-2">
                <div class='dx-field'>
                    <div class='dx-field-label'>Setup del programa</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.companyCosts.programSetup" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Costo mensual</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.companyCosts.monthlyCost" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Costo por dispersión</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="##.##%" [step]="0.001" [max]="10" [min]=".001"
                            [(value)]="program.companyCosts.dispersionCost">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Creación de tarjeta</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.companyCosts.cardCreation" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Costo anual del programa</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.companyCosts.yearlyCost" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Reemplazo de tarjeta</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.companyCosts.cardReplacement" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
            </div>
        </div>
        <!-- RIGHT  -->
        <div class=" responsive-paddings flex-grow-1">
            <!-- *****  -->
            <h3>Costos para tarjetahabiente</h3>
            <div class="round-border-2">
                <div class='dx-field'>
                    <div class='dx-field-label'>Reemplazo de tarjeta</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.userCosts.monthlyCost" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Creación de tarjeta</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.userCosts.cardCreation" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Costo anual</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.userCosts.yearlyCost" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Costo x transacción</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.userCosts.transactionCost" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Transferencia Virtual</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.userCosts.virtualWireingCost" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
                <div class='dx-field'>
                    <div class='dx-field-label'>Transferencia bancaria</div>
                    <div class='dx-field-value'>
                        <dx-number-box [showSpinButtons]="true" format="$ #,##0.##"
                            [(value)]="program.userCosts.bankWireingCost" [min]="0">
                        </dx-number-box>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="dx-field flex-end  responsive-paddings" *ngIf="!isEditing">
        <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="onFormSubmit($event)"
            text="Guardar programa" [visible]="btnIsDisabled">
        </dx-button>
    </div>
    <div class="dx-field flex-end  responsive-paddings" *ngIf="isEditing">
        <dx-button id="button" [useSubmitBehavior]="true" type="default" (onClick)="onFormUpdateSubmit($event)"
            text="Actualizar programa" [visible]="btnIsDisabled">
        </dx-button>
    </div>
</div>